import { t } from '@web-solutions/module-localization';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import styles from '../WebUpsaleThird/style.module.scss';
import { ReactComponent as BackIcon } from '../../../../assets/images/arrowLeft.svg';
import Button from 'src/onboarding/components/ui/button/Button';
import { ReactComponent as LoadingIcon } from '../../../../assets/images/loading-white.svg';

const FailedPayment = ({ onClose, onRetry, loading }) => {
    return (
      <>
        <div className={styles.failedContainer}>
          <div className={styles.back}>
            <button onClick={onClose}>
              <BackIcon />
            </button>
          </div>
          <div className={styles.container}>
            <div className={styles.circleFailed}></div>
            <svg className={styles.failedCheck} width='20' height='20' viewBox='0 0 40 40'>
              <line
                x1='13'
                y1='13'
                x2='27'
                y2='27'
                stroke='#fff'
                strokeWidth='3'
                strokeLinecap='round'
              />
              <line
                x1='27'
                y1='13'
                x2='13'
                y2='27'
                stroke='#fff'
                strokeWidth='3'
                strokeLinecap='round'
              />
            </svg>
          </div>
  
          <Title tag='h2'>{t('onboarding.upsaleThird.paymentFailed')}</Title>
          <Text size='m' medium className={styles.subTitle}>
            {t('onboarding.upsaleThird.failedSubtitle')}
          </Text>
          <Text size='m' medium className={styles.subTitle} style={{ marginTop: '20px' }}>
            {t('onboarding.upsaleThird.contact')}
            <a href='mailto:support@foodzee.com'> support@foodzee.com</a>
          </Text>
        </div>
        <div className={styles.nextWrapper}>
          <Button
            onClick={onRetry}
            //@ts-ignore
            title={loading ? <LoadingIcon /> : t('onboarding.upsaleThird.retry')}
            className={loading && 'disabled'}
            disabled={loading}
          />
        </div>
      </>
    );
  };

  export default FailedPayment